// App Android di mAIstro (passo 8, CAP-030): lo stesso sito gira dentro la
// cornice di Capacitor. Qui si riconosce l'app e si parla con i suoi plugin
// SENZA dipendenze nel sito: il ponte nativo di Capacitor inietta da solo
// window.Capacitor con isNativePlatform() e nativePromise(). Nel browser
// window.Capacitor non c'è e tutto torna al comportamento di sempre.

export function eAppNativa(win = typeof window === 'undefined' ? undefined : window) {
  const cap = win && win.Capacitor;
  return Boolean(cap && typeof cap.isNativePlatform === 'function' && cap.isNativePlatform() === true);
}

// D1 = A (Vale, 01/11, E140): nell'app solo email e password. «Accedi con
// Google» dentro una pagina incorporata è bloccato da Google, e Microsoft oggi
// non funziona. Nel sito i pulsanti restano come prima.
export function accessiSocialiVisibili({ googleClientId, microsoftClientId, appNativa }) {
  if (appNativa) return { google: false, microsoft: false };
  return { google: Boolean(googleClientId), microsoft: Boolean(microsoftClientId) };
}

// D4 = B (E142): mentre si registra lo schermo resta acceso (plugin KeepAwake
// dell'app). Nel browser non fa niente. Un errore del plugin non deve mai
// fermare la registrazione: si ignora e si risponde false.
export async function tieniSchermoAcceso(acceso, win = typeof window === 'undefined' ? undefined : window) {
  if (!eAppNativa(win) || typeof win.Capacitor.nativePromise !== 'function') return false;
  try {
    await win.Capacitor.nativePromise('KeepAwake', acceso ? 'keepAwake' : 'allowSleep', {});
    return true;
  } catch {
    return false;
  }
}

// D6 = A (01/11): la voce «Registratore di prova» nelle Impostazioni compare
// solo al superamministratore (is_admin, lo stesso controllo della pagina) e
// solo dentro l'app, dove non c'è la barra dell'indirizzo per arrivarci.
export function voceRegistratoreVisibile(user, appNativa) {
  return Boolean(user && user.is_admin === true && appNativa === true);
}

// FE-110 (02/11, AP04): il tasto o gesto Indietro di Android dentro l'app.
// Senza un ascoltatore Android mandava l'app in secondo piano da ogni pagina.
// Con il plugin ufficiale @capacitor/app l'ascolto passa dal ponte nativo
// (window.Capacitor.addListener), senza dipendenze nel sito; ascoltare
// «backButton» spegne il comportamento predefinito del plugin, quindi qui si
// decide tutto.
// La Home e la schermata di accesso sono pagine di partenza per nome: dopo
// l'accesso la pagina «precedente» alla Home è la schermata di accesso, e
// tornarci riporterebbe chi è già entrato al modulo di accesso.
export const PAGINE_DI_PARTENZA = ['/', '/auth/login'];

export function azioneTastoIndietro({ canGoBack, percorso }) {
  const pulito = String(percorso || '/').replace(/(.)\/+$/, '$1');
  if (PAGINE_DI_PARTENZA.includes(pulito)) return 'secondo-piano';
  return canGoBack === true ? 'indietro' : 'secondo-piano';
}

// Avvia l'ascolto (solo nell'app) e restituisce la funzione che lo toglie. In
// secondo piano con minimizeApp: l'app resta viva e l'accesso resta (mai
// exitApp, che la chiuderebbe).
export function ascoltaTastoIndietro(win = typeof window === 'undefined' ? undefined : window) {
  if (!eAppNativa(win) || typeof win.Capacitor.addListener !== 'function') return () => {};
  const ascolto = win.Capacitor.addListener('App', 'backButton', (evento) => {
    const azione = azioneTastoIndietro({
      canGoBack: Boolean(evento && evento.canGoBack),
      percorso: win.location.pathname,
    });
    if (azione === 'indietro') {
      win.history.back();
    } else if (typeof win.Capacitor.nativePromise === 'function') {
      win.Capacitor.nativePromise('App', 'minimizeApp', {}).catch(() => {});
    }
  });
  return () => {
    if (ascolto && typeof ascolto.remove === 'function') ascolto.remove();
  };
}
